import * as echarts from "echarts";
import { useEffect, useRef } from "react";
import { defaultColor } from "./util";

const Echart3DPie: React.FC<{
  dataOptions?: {
    name: string;
    value: number;
  }[];
}> = ({ dataOptions }) => {
  const myRef = useRef<any>();
  useEffect(() => {
    echarts.color;
    const myChart = echarts.init(myRef.current, undefined, {
      renderer: "canvas",
      useDirtyRect: false,
    });
    const animationDuration = 8000;
    const option = {
      animationDuration,
      tooltip: {
        trigger: "item",
        backgroundColor: "#fff",
        formatter: function (params: any) {
          return params.data["name"] + "\n" + params.data["value"] + "</span>";
        },
      },
      legend: {
        selectedMode: true,
        orient: "vertical",
        itemWidth: 8,
        itemHeight: 8,
        icon: "circle",
        right: "10",
        top: "center",
        textStyle: {
          fontSize: 14,
          color: "#fff",
        },
        data: dataOptions?.map((item) => item.name),
      },
      series: [
        {
          name: "",
          type: "pie",
          animationDuration: animationDuration,
          //   hoverAnimation: true,
          //   legendHoverLink: true,
          cursor: "default",
          radius: ["32%", "50%"],
          center: ["45%", "50%"],
          color: defaultColor,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          zlevel: 1,
          itemStyle: {
            normal: {
              borderColor: "#183948",
            },
            ellipsis: {
              borderColor: "#183948",
            },
          },
          tooltip: {
            show: false,
          },
          data: dataOptions?.map((item) => {
            return {
              name: "",
              value: item.value,
            };
          }),
        },
        {
          name: "",
          type: "pie",
          zlevel: 2,
          cursor: "default",
          hoverAnimation: true,
          legendHoverLink: true,
          animationDuration: animationDuration,

          radius: ["37%", "50%"],
          center: ["45%", "50%"],
          color: defaultColor,

          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          itemStyle: {
            normal: {
              // shadowBlur: 15,
              // shadowColor: 'rgba(0, 0, 0, 0.5)',
              borderColor: "#183948",
              // borderWidth:'10',
            },
            ellipsis: {
              borderColor: "#183948",
            },
          },
          tooltip: {
            show: false,
          },
          data: dataOptions?.map((item) => {
            return {
              name: "",
              value: item.value,
            };
          }),
        },
        {
          name: "title",
          type: "pie",
          zlevel: 3,
          //   hoverAnimation: true,
          //   legendHoverLink: true,
          animationDuration: animationDuration,
          radius: ["43%", "50%"],
          center: ["45%", "50%"],
          color: defaultColor,
          //   color: [
          //     "rgba(0, 150, 254, 1)",
          //     "rgba(2, 205, 206, 1)",
          //     "rgba(253, 160, 0, 1)",
          //     "rgba(191, 40, 18, 1)",
          //   ],
          label: {
            show: true,
            formatter: (param: any) => {
              return (
                "{a|" + param.name + "}\n{hr|}\n" + "{d|" + param.value + "}"
              );
            },
            padding: [0, -30],
            textStyle: {
              lineHeight: 15,
            },
            // alignTo: "edge", // label两端对称布局
            //  ECharts v4.6.0 版本起，提供了 'labelLine' 与 'edge' 两种新的布局方式
            // margin: 90, // 布局为两端对称时候需要外边距防止图表变形 数值随意不要太大
            rich: {
              a: {
                padding: [4, 10, 0, 10], // 4边距是文字和hr间距，此处的边距10用于解决label和引导线有间距问题
                color: "#fff",
              },
              d: {
                padding: [0, 10, 4, 10],
                color: "#fff",
              },
              hr: {
                borderWidth: 1,
                width: "100%",
                height: 0,
                borderColor: " ",
              },
            },
          },
          labelLine: {
            show: true,
            // showAbove:true,
            length: 15,
            length2: 40,
            lineStyle: {
              color: "#fff",
            },
          },
          itemStyle: {
            shadowBlur: 15,
            shadowColor: "#fff",
            borderColor: "#fff",
          },
          data: dataOptions,
        },
      ],
    };

    if (option && typeof option === "object") {
      myChart.setOption(option);
    }
    const interValId = setInterval(() => {
      // option.graphic.elements[0].rotation =
      //   option.graphic.elements[0].rotation + 5;
      myChart.setOption(option);
    }, 200);
    return () => {
      clearInterval(interValId);
    };
  }, [dataOptions]);
  return (
    <div
      ref={myRef}
      style={{
        height: "260px",
      }}
    ></div>
  );
};
export default Echart3DPie;
